import { render, staticRenderFns } from "./service-request-status-card.vue?vue&type=template&id=0da118dd&"
import script from "./service-request-status-card.vue?vue&type=script&lang=js&"
export * from "./service-request-status-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports